<app-header-user></app-header-user>

<main class="pt-20"> <!-- Add padding to offset the fixed header -->
  <router-outlet></router-outlet>
</main>

<!-- Footer -->
<app-footer></app-footer>
